export default __webpack_public_path__ + "static/dook-3fd8eb73227c6d92c1533c2be6cc6ba7.jpeg";